import { useEffect, useState } from 'react';
import { useLoyaltyClubStore } from '~contexts/mobx';
import type { RewardOptionCoupon } from '~stores/loyalty-club';

/**
 * The reward-option coupons, read once per page load: the only correct read
 * of stock, shared here by the two Milestone rewards stock cards and (slice
 * 10) the rewards inventory table, so neither re-reads nor re-derives it.
 */
export type CampaignCouponStockState =
    | { status: 'loading' }
    | { status: 'ready'; coupons: RewardOptionCoupon[] }
    | { status: 'unavailable'; reason: string };

const COUPONS_FAILED =
    'The reward coupon configuration could not be loaded, so stock cannot be read.';

export const useCampaignCouponStock = (): CampaignCouponStockState => {
    const loyaltyClubStore = useLoyaltyClubStore();
    const [state, setState] = useState<CampaignCouponStockState>({
        status: 'loading',
    });

    useEffect(() => {
        let cancelled = false;

        const load = async () => {
            try {
                const coupons = await loyaltyClubStore.fetchRewardOptionCoupons();
                if (!cancelled) {
                    setState({ status: 'ready', coupons });
                }
            } catch {
                if (!cancelled) {
                    setState({ status: 'unavailable', reason: COUPONS_FAILED });
                }
            }
        };

        void load();
        return () => {
            cancelled = true;
        };
    }, [loyaltyClubStore]);

    return state;
};
